import * as React from "react";
import { useState } from "react";
import {
    useDataProvider,
    useRefresh,
    useNotify,
} from "react-admin";
import { IconButton, Tooltip } from "@material-ui/core";
import { Description, Send, Delete } from "@material-ui/icons";
import styled from "styled-components";
import ResultLinks from "../../common/ResultLinks";
import PdfPreview from "./PdfPreview";
import { connect } from "react-redux";
import { deleteLeadLocal } from "../../redux/actions";

const Actions: React.FC<any> = ({ record, deleteLeadLocal }) => {

    const notify = useNotify();
    const dataProvider = useDataProvider();
    const refresh = useRefresh();
    const [pressed, setPressed] = useState(false);
    const [previewPressed, setPreviewPressed] = useState(false);
    const [pdf, setPdf] = useState("");

    const sendPdf = async (e: any) => {
        e.stopPropagation();
        if (!window.confirm(`Are you sure you want to send a letter to ${record.contact}? This can't be undone`)) {
            return false;
        }
        setPressed(true);
        try {
            await dataProvider.create(`letter/${record.id}/send`, { data: {} });
            notify(`Letter sent to ${record.contact}!`);
            refresh();
        } catch (e) {
            setPressed(false);
            notify(e.toString());
            console.error(e);
        }
        return true;
    }

    const openPdf = async (e: any) => {
        e.stopPropagation();
        setPreviewPressed(true);
        try {
            const { data } = await dataProvider.getOne(`letter`, { id: record.id });
            setPdf(data.pdf);
        } catch (e) {
            console.error(e);
            notify(`An error occured fetching the PDF`);
        }
        setPreviewPressed(false);
    }

    const onClose = (e: any) => {
        e.stopPropagation()
        setPdf("");
    }

    const convertBackToResult = async (e: any) => {
        e.stopPropagation();
        try {
            await dataProvider.update("search_result", {
                id: record._id,
                data: { status: "fetched" },
                previousData: {
                    id: record._id,
                }
            });
            notify(`Removed as a lead, check results page`);
            deleteLeadLocal(record.id);
        } catch (e) {
            console.error(e);
        }
    }

    if (!record) {
        return null;
    }

    return (
        <>
            {pdf && (
                <PdfPreview
                    onClose={onClose}
                    pdf={pdf}
                    title={record.propertyAddress}
                    sendPdf={sendPdf}
                />
            )}
            <Row>
                <Tooltip title="Remove lead">
                    <IconButton
                        onClick={convertBackToResult}
                        disabled={record.letterSent}
                    >
                        <Delete />
                    </IconButton>
                </Tooltip>
                <ResultLinks record={record} />
                <Tooltip title="Preview letter">
                    <IconButton onClick={openPdf} disabled={previewPressed}>
                        <Description />
                    </IconButton>
                </Tooltip>
                <Tooltip title={record.letterSent ? `Letter sent` : `Send letter`}>
                    <IconButton
                        disabled={record.letterSent || pressed}
                        onClick={sendPdf}
                    >
                        <Send />
                    </IconButton>
                </Tooltip>
            </Row>
        </>
    )
}

const Row = styled.div`
    display: flex;
    flex-direction: row;
`;

export default connect(undefined, {
    deleteLeadLocal,
})(Actions);
